__turbopack_context__.v({
  "className": "outfit_47bef5d4-module__0wHsgq__className",
  "variable": "outfit_47bef5d4-module__0wHsgq__variable",
});
